var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenLink = function SvgOpenLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12 12 8-8M14 4h6v6",
    className: "stroke-icon-main"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    d: "M9.444 19H9v0c-.93 0-1.395 0-1.776-.102a3 3 0 0 1-2.122-2.122C5 16.396 5 15.93 5 15v-.44000000000000006M14.556 19H15v0c.93 0 1.395 0 1.776-.102a3 3 0 0 0 2.122-2.122C19 16.396 19 15.93 19 15v-.44000000000000006M9.444 5H9v0c-.93 0-1.395 0-1.776.102a3 3 0 0 0-2.122 2.122C5 7.605 5 8.07 5 9v.44000000000000006"
  })));
};
export default SvgOpenLink;